import HandymanCalendar from "../../../../components/calendar/HandymanCalendar";

const HandymanCalendarRoute = () => {
  return <HandymanCalendar />;
};

export default HandymanCalendarRoute;
